module.exports = __webpack_public_path__ + "asset/form1--a98d35.png";